import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import ViewModalImage from 'modules/common/components/ViewModalImage';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

const form = [{
  floor: '',
  area: '',
}];

function FloorAreaTab({
  historyInfo,
  isLoading,
  getFloorPlanLogs,
  historyFloorAreaList,
}) {

  const setModal = useContext(ModalContext);
  const [, setFormData] = useState(form);

  const handleViewImage = (value) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      title: 'View Floor Plan',
      content: <ViewModalImage value={value} />,
      modalSize: 'modal-lg',
    });
  };

  const formatFloorArea = (data) => {
    const format = data.map(item => ({
      id: _.get(item, 'id'),
      floor: _.get(item, 'attributes.floor'),
      area: _.get(item, 'attributes.area'),
      rptax_actual_use_id: _.get(item, 'attributes.rptax_actual_use_id'),
    }));
    return format;
  };

  const onSetFormData = () => {
    setFormData(formatFloorArea(historyFloorAreaList));
  };

  useEffect(() => {
    onSetFormData();
    getFloorPlanLogs(historyInfo.id);
  }, []);

  return (
    <>
      <div className="p-3 mr-2">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <div className="row mb-3 d-flex align-items-center">
              <div className="col py-0">
                <h3 className="m-0 text-color font-weight-bold">Floor Area</h3>
              </div>
            </div>

            {(historyFloorAreaList && historyFloorAreaList.length <= 0) && (
              <div className="d-flex align-items-center justify-content-center h-100">
                <div className="text-center mx-auto py-4">
                  <img
                    src={emptyStateImage}
                    className="img-responsive image-wrapper mb-4 mt-3"
                    alt="Empty State"
                  />
                  <p className="emp-title mb-0"> No Item Found </p>
                </div>
              </div>
            )}

            {(historyFloorAreaList.length > 0) && (
              <div className="row my-3 mx-0">
                <table className="css-table table table-sm table-striped table-hover">
                  <thead className="table-header">
                    <tr>
                      <td width="200"><b>Floor Number</b></td>
                      <td width="200"><b>Area</b></td>
                      <td width="250"><b>Actual Use</b></td>
                    </tr>
                  </thead>
                  <tbody>
                    {historyFloorAreaList.map((item) => (
                      <tr key={item.id}>
                        <td width="200" className="history-color">{_.get(item, 'attributes.floor')}</td>
                        <td width="200" className="history-color">{_.get(item, 'attributes.area') || 0}</td>
                        <td width="250" className="history-color">{_.get(item, 'attributes.actual_use') || ''}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
        <hr />
        <div className="title font-weight-bold">
          Building Plan
        </div>
        <div className="row mb-3 d-flex align-items-center">
          <div className="col-6" />
          <div className="col-6">
            <button
              className="btn-blank"
              type="button"
              onClick={handleViewImage(_.get(historyInfo, 'attributes.floor_plan_photo_url'))}
            >
              <img
                className="w-100 rounded"
                src={
                  !_.isObject(_.get(historyInfo, 'attributes.floor_plan_photo_url') || '')
                    ? (_.get(historyInfo, 'attributes.floor_plan_photo_url') || ImagePlaceholder)
                    : (_.get(historyInfo, 'attributes.floor_plan_photo_url.cdnUrl') || ImagePlaceholder)
                }
                alt=""
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

FloorAreaTab.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  historyInfo: PropTypes.instanceOf(Object),
  getFloorPlanLogs: PropTypes.instanceOf(Function).isRequired,
  historyFloorAreaList: PropTypes.instanceOf(Array).isRequired,
};

FloorAreaTab.defaultProps = {
  historyInfo: {}
};

const mapStateToProps = ({ api }) => ({
  historyFloorAreaList: _.get(api, `${c.GET_FLOOR_PLAN_LOGS}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_FLOOR_PLAN_LOGS) > -1,
});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    actions,
  ),
]);

export default enhance(FloorAreaTab);
